import { galleryItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GallerySection() {
  return (
    <section id="gallery" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          kicker="实锤现场"
          title="精选封面图集"
          desc="封面即目录：点开一组，就能按拍摄或截取顺序一路看下去。"
          actionLabel="浏览全部图集"
          actionHref="#overview"
        />

        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
          {galleryItems.map((item) => (
            <article key={item.id} className="group">
              <a href="#overview" className="block">
                <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} - 黑料图片证据截图图集`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                  <span className="absolute right-3 top-3 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-semibold text-foreground-900">
                    {item.count}
                  </span>
                  <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-foreground-950">
                    {item.tag}
                  </span>
                  <div className="absolute inset-x-0 bottom-0 p-4">
                    <h3 className="font-heading text-sm font-bold leading-snug text-background-50 md:text-base">
                      {item.title}
                    </h3>
                  </div>
                </div>
                <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}